
// * ========================================================================
// * municipality chart and table
// * ========================================================================
import Tablesorter from './../table-sorter';

const municipality = (function(){
    let chartData = null;

    /**
     *
     * Show new cases per day table
     *
     * @param {Array} data - covid data
     */
    function showTable(data) {
        let headings = '<th>Kunta</th>';
        headings += '<th class="align-right" data-sort="number">Ilmaan&shy;tuvuus</th>';
        headings += '<th class="align-right" data-sort="number"><span class="chart-options-mobile">Yht.</span><span class="chart-options-desktop">Yhteensä</span></th>';
        headings += '<th class="align-right sorting" data-sort="number">Uusia</th>';

        const markup = ['<tr>'+headings+'</tr>'];

        const rateString = 'rate_' + window.config.rateDays;
        for (let municipalityKey of Object.keys(data.municipalities)) {
            const municipality = data.municipalities[municipalityKey];
            const count = municipality.count === 0 ? 0 : municipality.count;
            const countStr = municipality.count === 0 ? '0 - 4' : count;

            let change = municipality.count === 0 ? 0 : municipality.change;
            let changeStr = municipality.count === 0 ? '' : change ? change > 0 ? '<span class="color-red">+'+municipality.change+'</span>' : municipality.change : 0;

            const rate = municipality[rateString] && municipality[rateString] > 0 ? municipality[rateString] : 0;
            let rateStr = rate === 0 ? '' : rate;

            // 10 >= kiihtymisvaihe 18 >= leviämisvaihe
            if (rate >= 18) {
                rateStr = '<span class="color-red">'+rateStr+'</span>';
            } else if (rate >= 10) {
                rateStr = '<span class="color-orange">'+rateStr+'</span>';
            }

            let row = '<tr>';
            row += '<td data-dataset-id="'+ municipality.id +'" data-value="'+municipalityKey+'">'+municipalityKey+'</td>';
            row += '<td data-value="'+rate+'" class="align-right">'+rateStr+'</td>';
            row += '<td data-value="'+count+'" class="align-right">'+countStr+'</td>';
            row += '<td data-value="'+change+'" class="align-right">'+changeStr+'</td>';
            row += '</tr>';

            markup.push(row);
        }

        const tableContainer = document.getElementById('municipality-total-table');
        tableContainer.innerHTML = '<table class="table slim">'+markup.join('')+'</table>';
        const table = tableContainer.querySelector('table');

        const tablesorter = new Tablesorter(table);

        // Set new order
        const sorter = table.querySelector('th.sorting');
        tablesorter.sortBy(sorter);
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     * @param {Object} options - chart options
     */
    function init(data, options) {
        chartData = data;
        showTable(chartData);
    }

    function reload() {
        // Re render table
        showTable(chartData, window.config);
    }

    return {
        init,
        reload
    }

})();

export default municipality;
